import { SubmittalDto, SubmittalRequestDto } from 'src/api/FiretrolApiClient';
import { submittalApiClient } from 'src/api/FiretrolApiClientInstances';
import { createModuleMutations } from 'src/api/queries/workflowModules/createModuleMutations';
import { queryKeys } from 'src/api/queries/queryKeys';

const mutations = createModuleMutations<SubmittalDto, SubmittalRequestDto>({
  label: 'submittal',
  saveOp: 'submittal.save',
  detailKey: queryKeys.submittals.detail,
  getId: (dto) => dto.id,
  save: (jobId, request) =>
    submittalApiClient.createOrUpdateSubmittal(jobId, request),
  attachFromDocument: (jobId, documentId) =>
    submittalApiClient.attachFromDocument(jobId, { documentId }),
  rotateExternalAccess: (jobId, id) =>
    submittalApiClient.rotateExternalAccess(jobId, id),
  uploadTempFile: (file, category) =>
    submittalApiClient.uploadTempFile(
      { data: file, fileName: file.name },
      category,
    ),
  generatePdf: (jobId, id) =>
    submittalApiClient.generateSubmittalPdf(jobId, id),
  previewPdf: (jobId, id) => submittalApiClient.previewSubmittalPdf(jobId, id),
  logPdf: (jobId, statuses, contactId) =>
    submittalApiClient.getSubmittalLogPdf(jobId, statuses, contactId),
});

export const useSaveSubmittal = mutations.useSave;
export const useAttachSubmittalDocument = mutations.useAttachFromDocument;
export const useRotateSubmittalExternalAccess =
  mutations.useRotateExternalAccess;
export const useGenerateSubmittalPdf = mutations.useGeneratePdf;
export const usePreviewSubmittalPdf = mutations.usePreviewPdf;
export const useSubmittalLogPdf = mutations.useLogPdf;
